export interface RouteDefinition {
  path: string;
  // eslint-disable-next-line
  url: (args?: any) => string;
}

export interface AppRoutes {
  [key: string]: RouteDefinition | AppRoutes;
}

export const routes = {
  login: {
    path: 'login',
    url: () => '/login',
  },
  userInvitationLogin: {
    path: 'user-invitation-login',
    url: () => '/user-invitation-login',
  },
  emailLinkLogin: {
    path: 'email-link-login',
    url: () => '/email-link-login',
  },
  termsAndConditions: {
    path: 'terms-and-conditions',
    url: () => '/terms-and-conditions',
  },
  onboarding: {
    index: {
      path: 'onboarding',
      url: () => '/onboarding',
    },
    brand: {
      path: 'onboarding/brand',
      url: () => '/onboarding/brand',
    },
    creator: {
      path: 'onboarding/creator',
      url: () => '/onboarding/creator',
    },
  },
  welcome: {
    brand: {
      path: 'welcome_brand',
      url: () => '/welcome_brand',
    },
    creator: {
      path: 'welcome_creator',
      url: () => '/welcome_creator',
    },
  },
} as const satisfies AppRoutes;
